/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Broker Audit Answer model
 */
export class BadAnswerModel { 
    /**
     * ID of the question answered
     */
    QuestionID?: number;
    /**
     * Set to True if question has been answered by the user
     */
    AnswerSpecified?: boolean;
    /**
     * Yes = 1, No = 2, NA = 3
     */
    AnswerTypeID?: number;
    /**
     * Explanation for No answers where the NoAnswerRequiresExplanation flag on the question is set to True
     */
    Explanation?: string;
}



// WEBPACK FOOTER //
// ./src/app/model/badAnswerModel.ts